/** Search parameters used in the planogram page. */
export const searchParametersProduct = {
    CATEGORIES: 'categories',
    MANAGERS: 'managers',
    NAME: 'name',
    STATUS: 'status',
    SUPPLIERS: 'suppliers',
}

/** Search params used in the product API. */
export const searchParametersProductApi = {
    CATEGORIES: 'category__id__in',
    MANAGERS: 'client__id__in',
    NAME: 'name__icontains',
    STATUS: 'disabled',
    SUPPLIERS: 'supplier__id__in',
}
